import { render } from "./RemediationBox.vue?vue&type=template&id=dcc13aac&scoped=true&ts=true"
import script from "./RemediationBox.vue?vue&type=script&lang=ts"
export * from "./RemediationBox.vue?vue&type=script&lang=ts"

import "./RemediationBox.vue?vue&type=style&index=0&id=dcc13aac&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc13aac"]])

export default __exports__